import axios, { Canceler } from 'axios';

import { IDocument, IPage } from '../infrastructure/interfaces';
import { productType, ProductType } from '../infrastructure/ProductType';
import { getPages, mapPagesToSpreads } from './PageService';
import { PageType } from '../infrastructure/PageType';
import { isRightPageOnlyPlaceholderType } from '../infrastructure/placeholderTypes';
const CancelToken = axios.CancelToken;
let cancelSave: Canceler | null;

const buildDocumentTemplate = (productTypeLocal: ProductType, customData: any) => {
  let template: IDocument = {
    id: 0,
    type: "Catalog",
    name: '',
    pages: [],
    spreads: [],
    crops: [],
    logos: [],
    brandings: [],
    branding: null,
    coverImage: null,
    postcardImageFront: null,
    postcardImageBack: null,
    posterImageBackground: null,
    companyInfo: {
      divisionName: '',
      phoneNumber: '',
      email: '',
      isEnabled: true,
    },
    additionalInfo: {
      text: '',
      isEnabled: true,
      date: '',
    },
    title: 'Advanced<br/>Solutions<br/>to Maximize<br/>Crop Outcomes.',
  }; switch (productTypeLocal) {
    case productType.Brochure:
      {
        template = {
          ...template,
          type: productTypeLocal,
          name: 'My New Quad Fold',
          pages: customData.pages,
          spreads: customData.spreads,
        };
        break;
      }
    case productType.Catalog:
      {
        template = {
          ...template,
          type: productTypeLocal,
          name: 'My New Catalog',
          pages: customData.pages,
          spreads: customData.spreads,
        };
        break;
      }
    case productType.Bulletin:
      {
        template = {
          ...template,
          type: productTypeLocal,
          name: 'My New Bulletin',
          pages: customData.pages,
          spreads: customData.spreads,
        };
        break;
      }
    case productType.Postcard:
      {
        template = {
          ...template,
          type: productTypeLocal,
          name: 'My New Postcard',
          pages: customData.pages,
          spreads: customData.spreads,
        };
        break;
      }
    case productType.Poster:
      {
        template = {
          ...template,
          type: productTypeLocal,
          name: 'My New Poster',
          pages: customData.pages,
          spreads: customData.spreads,
        };
        break;
      }
    default:
      template = { ...template };
  }
  return template;
};

const DocumentService = {
  getCreatedPdf(fileName: string) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/getPdf`, { params: { fileName }, responseType: 'blob' })
        .then((response) => {
          resolve(response.data);
        })
        .catch(error => reject(error));
    });
  },
  getDocument(type: ProductType, pagesCount: number): IDocument {
    const pages = getPages(type, pagesCount);
    const spreads = mapPagesToSpreads(pages, type);
    const documentData = {
      pages,
      spreads,
    };
    return buildDocumentTemplate(type, documentData);
  },
  getDocumentList(userID: string) {
    return new Promise((resolve, reject) => {
      axios
        .get('/userDocuments?userID=' + userID)
        .then((res) => {
          resolve(res.data);
        })
        .catch(error => reject(error));
    });
  },

  createDocument(document: IDocument, userID: string) {

    return new Promise((resolve, reject) => {
      axios
        .post('/documents?userID=' + userID, { document })
        .then((res) => {
          document.id = res.data;
          resolve(document);
        })
        .catch(error => reject(error));
    });
  },

  cloneDocument(document: IDocument, name: string, userID: string) {
    let body : {} = { 'name': name, 
                      'userID': userID}
    return new Promise((resolve, reject) => {
      axios
        .post('/documents' + "/copy/" + document.id, body)
        .then((res) => {
          console.log(res.data)
          resolve(res.data);
        })
        .catch(error => reject(error));
    });
  },
  saveDocument(document: IDocument, userID: string) {

    if (cancelSave) {
      cancelSave();
      cancelSave = null;
    }

    return new Promise((resolve, reject) => {
      axios
        .put('/documents' + "/" + document.id + '?userID=' + userID, { document }, {
          cancelToken: new CancelToken((c) => {
            cancelSave = c;
          }),
        })
        .then((res) => {
          resolve(document);
        })
        .catch(error => reject(error));
    });
  },
  validateCrops(document: IDocument) {
    return document && document.crops.length > 0;
  },
  validateCompanyInfo(document: IDocument) {
    const { companyInfo } = document;
    for (const key in companyInfo) {
      if (typeof companyInfo[key] === 'string' && !companyInfo[key]) {
        return false;
      }
    }
    return true;
  },
  dranNDropHandler(document: IDocument, action: any) {
    const { index, model, spread } = action.data;
    const spreadLeftPlaceholders = spread.left ? spread.left.placeholders : [];
    const spreadRightPlaceholders = spread.right ? spread.right.placeholders : [];
    const placeholders = [
      ...spreadLeftPlaceholders,
      ...spreadRightPlaceholders,
    ];

    placeholders[index].data = model.data;
    placeholders[index].type = model.type;

    let newPage: IPage;
    const leftPage = { ...spread.left, placeholders: placeholders.splice(0, spreadLeftPlaceholders.length) };
    const rightPage = spread.right ? { ...spread.right, placeholders: [...placeholders] } : null;
    const newSpread = {
      left: leftPage,
      right: rightPage,
    };

    newPage = (index < spreadLeftPlaceholders.length) ? newSpread.left : newSpread.right;

    const pages = document.pages.map((item) => {
      let page = (newPage.number === item.number) ? newPage : item;
      return page;
    });

    return {
      ...document,
      pages,
    };
  },
  removeProductHandler(document: IDocument, action: any) {
    const { index, spread } = action.data;
    const spreadLeftPlaceholders = spread.left.placeholders;
    const spreadRightPlaceholders = spread.right ? spread.right.placeholders : [];
    const placeholders = [
      ...spreadLeftPlaceholders,
      ...spreadRightPlaceholders,
    ];

    placeholders[index].data = null;
    placeholders[index].type = null;

    let newPage: IPage;
    const leftPage = { ...spread.left, placeholders: placeholders.splice(0, spreadLeftPlaceholders.length) };
    const rightPage = spread.right ? { ...spread.right, placeholders: [...placeholders] } : null;
    const newSpread = {
      left: leftPage,
      right: rightPage,
    };

    newPage = (index < spreadLeftPlaceholders.length) ? newSpread.left : newSpread.right;

    const pages = document.pages.map((item) => {
      let page = (newPage.number === item.number) ? newPage : item;
      return page;
    });

    return {
      ...document,
      pages,
    };
  },
  movePlaceholderHandler(document: IDocument, action: any) {
    const { dragInfo, spread } = action.data;
    const { dragIndex, dropIndex } = dragInfo;

    const spreadLeftPlaceholders = spread.left.placeholders;
    const spreadRightPlaceholders = spread.right ? spread.right.placeholders : [];
    const placeholders = [
      ...spreadLeftPlaceholders,
      ...spreadRightPlaceholders,
    ];

    const oldDrag = placeholders[dragIndex];
    const oldDrop = placeholders[dropIndex];

    oldDrop.data = null;
    oldDrop.type = null;

    placeholders[dragIndex] = oldDrop;
    placeholders[dropIndex] = oldDrag;

    const leftPage = { ...spread.left, placeholders: placeholders.splice(0, spreadLeftPlaceholders.length) };
    const rightPage = spread.right ? { ...spread.right, placeholders: [...placeholders] } : null;
    const newSpread = {
      left: leftPage,
      right: rightPage,
    };

    const pages = document.pages.map((item) => {
      let page;
      if (newSpread.left.number === item.number) {
        page = newSpread.left;
      } else if (newSpread.right.number === item.number) {
        page = newSpread.right;
      } else {
        page = item;
      }
      return page;
    });

    const spreads = mapPagesToSpreads(pages, document.type);

    return {
      ...document,
      pages,
      spreads,
    };
  },
  validatePhone(input:any) {
    const val = input.value;
    if (/_/g.test(val) || !val) {
      return false;
    }
    return true;
  },
  validatePagesCount(document: IDocument) {
    if (document.type === 'Catalog') {
      const { pages } = document;
      const pagesLength = pages.length;
      if (pagesLength <= 16) {
        return pagesLength % 4 === 0;
      }

      return pagesLength % 2 === 0;
    }
    return true;
  },
  validateDividers(document: IDocument) {
    const invalidPages: Array<string> = [];
    if (document.type === 'Catalog') {
      const pages = document.pages.filter(p => p.type === PageType.Page);
      for (const page of pages) {
        const placeholder = page.placeholders[0];
        if (page.position === 'left' && isRightPageOnlyPlaceholderType(placeholder.type)) {
          invalidPages.push(String(page.number));
        }
      }
      const isError:boolean = (invalidPages.length > 0);
      return  { error: isError, pages: invalidPages };
    }
    return { error: false, pages: invalidPages };
  },
  validateDocument(document: IDocument) {
    const pagesValid = this.validatePagesCount(document);

    let stringErrors:Array<string> = [];
    let result = { errors: false, pagesError: false, dividersError: stringErrors };

    if (!pagesValid) {
      result = {
        ...result,
        errors: true,
        pagesError: true,
      };
    }
    
    return result;
  },
};

export default DocumentService;



// WEBPACK FOOTER //
// ./src/services/DocumentService.ts